import {
  MessageError,
  MessageWarn,
  MessageInfo,
  MessageSuccess,
} from './styles';
import Icon from './Icon';

export type MessageProps = {
  children: React.ReactNode;
  type: 'error' | 'info' | 'warn' | 'success';
};

export default function Message({ children, type }: MessageProps) {
  switch (type) {
    case 'error':
      return (
        <MessageError>
          <Icon type={type} fill="#D10000" />
          <p>{children}</p>
        </MessageError>
      );
    case 'warn':
      return (
        <MessageWarn>
          <Icon type={type} fill="#bd5b00" />
          <p>{children}</p>
        </MessageWarn>
      );
    case 'success':
      return (
        <MessageSuccess>
          <Icon type={type} fill="#008A00" />
          <p>{children}</p>
        </MessageSuccess>
      );
    default:
      return (
        <MessageInfo>
          <Icon type={type} fill="#005CDE" />
          <p>{children}</p>
        </MessageInfo>
      );
  }
}
